import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, TextField, Container, Typography, Box, Alert, Stack } from "@mui/material";
import axios from "axios";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/login/`, {
        username,
        password,
      },{
        headers: {
          "Content-Type": "application/json"
        },
      });
      if (response.status === 200) {
        console.log("access token generated successfully");
        localStorage.setItem("access_token", response.data.access); // Store token with client localStorage
        localStorage.setItem("refresh_token", response.data.refresh);
        //console.log("ACCESS TOKEN: ", localStorage.getItem("access_token"));
        // console.log("REFRESH TOKEN: ",response.data.refresh);
        const token = response.data.access;
        axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/user-info/`,{
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.data.userType === 'test_taker') {
            onLogin(response.data.access); // Pass token to parent component
            navigate('/', {replace:true});
          } else if (response.data.userType === 'district_admin') {
            onLogin(response.data.access);
            navigate('/statistics', {replace:true});
          }
        })
        .catch((error) => {
          console.error("Failed to fetch user info:", error);
        });
        
        
      }
    } catch (err) {
      console.log(err)
      setError("Invalid username or password");
    }
  };

  return (
    <Box>
    <Box sx={{
      textAlign:'center',
      bgcolor:'primary.dark',
      p:4
    }}>
      <Typography variant="h2" sx={{fontWeight:650, color:'white', cursor:'pointer'}} onClick={() => navigate('/')}>ExamPortal</Typography>
      <Typography variant="h6" sx={{color:'white'}}>Efficient, Secure, and Painless Pre-Employment Testing</Typography>
    </Box>
    
    <Container maxWidth="xs">
      <Box sx={{mt: 10}} textAlign="center">
        <Typography variant="h4" gutterBottom>
          Login
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            label="Email"
            variant="outlined"
            value={username}
            onChange={(e) => setUsername(e.target.value.toLowerCase())}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Password"
            type="password"
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error &&<Alert severity="error" onClose={() => {setError('')}}>{error}</Alert>}
          <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: 2 }}>
            Login
          </Button>
        </form>
      </Box>
      <Stack direction={'row'} spacing={2} sx={{mt:2}}>
        <Button
          onClick={() => navigate("/register")}
          fullWidth
          variant="outlined"
          color="primary"
          sx={{ mt: 2 }}
        >
          New User
        </Button>
        <Button
          onClick={() => navigate("/password-reset-request")}
          fullWidth
          variant="outlined"
          color="primary"
          sx={{ mt: 2 }}
        >
          Forgot Password
        </Button>
      </Stack>
      
        
    </Container>
    <Box sx={{position:'fixed', right:0, bottom:0, p:1}}>
      <Typography>v2.0.4</Typography>
    </Box>
    </Box>
    
  );
};

export default Login;